module.exports = __webpack_public_path__ + "img/banner.4e83441e.png";